import axios from 'axios';
import OktaService from './services/OktaService';
import auth from './content/common/auth';

// export const baseURL = 'https://a360-dev.data-axle.com';
// export const baseURL = 'http://localhost:8000'; // Deployment
export const baseURL = '';
export const aqferDBDSURL = 'https://dbds.data-axle.com/v2';
export const aqferGraphDSURL = 'https://tag2.data-axle.com/v2';

function getStoredClientId() {
  try {
    const raw = localStorage.getItem('client');
    if (!raw || raw === 'undefined' || raw === 'null') return null;
    return JSON.parse(raw)?.company_id ?? null;
  } catch {
    return null;
  }
}

export const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 3600000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    Client: getStoredClientId(),
  },
});

let renewPromise = null;

async function getOktaBearer() {
  const token = await OktaService.getAccessToken();
  return token ? `Bearer ${token}` : null;
}

axiosInstance.interceptors.request.use(
  async config => {
    try {
      const bearer = await getOktaBearer();
      if (bearer) {
        config.headers['Authorization'] = bearer;
      }
    } catch (err) {
      console.warn('Failed to attach Okta token', err);
    }

    if (
      config?.url?.includes(aqferDBDSURL) ||
      config?.url?.includes(aqferGraphDSURL)
    ) {
      if (config.headers?.Authorization) {
        delete config.headers?.Authorization;
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(response => response, async function(
  error
) {
  const originalRequest = error.config;
  if (typeof error.response === 'undefined') {
    console.log('A server/network/CORS error occurred.');
    return Promise.reject(error);
  }

  // A360 idle lockout (Okta Bearer may still be valid). Match on code so logout
  // still runs if a proxy/gateway remaps 401 → 403.
  if (error.response.data?.code === 'inactivity_timeout') {
    console.log('Session expired due to inactivity');
    axiosInstance.defaults.headers['Authorization'] = null;
    axiosInstance.defaults.headers['Client'] = null;
    // Do not clear Okta tokens before logout — idToken is required for Okta /v1/logout.
    await auth.logout();
    return Promise.reject(error);
  }

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    try {
      if (!renewPromise) {
        renewPromise = OktaService.renewTokens().finally(() => {
          renewPromise = null;
        });
      }
      const token = await renewPromise;
      if (!token) {
        throw new Error('Okta renew returned no token');
      }
      const bearer = `Bearer ${token}`;
      axiosInstance.defaults.headers['Authorization'] = bearer;
      originalRequest.headers['Authorization'] = bearer;
      if (originalRequest.data instanceof FormData) {
        originalRequest.headers['Content-Type'] = 'multipart/form-data';
      }
      return axiosInstance(originalRequest);
    } catch (renewErr) {
      console.log('Okta token renew failed', renewErr);
      axiosInstance.defaults.headers['Authorization'] = null;
      axiosInstance.defaults.headers['Client'] = null;
      await auth.logout();
      return Promise.reject(renewErr);
    }
  }

  return Promise.reject(error);
});
